import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../../core/models/RouteHelper';
import MobileMatchLog from './MobileMatchLog';

interface OwnProps {}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(MobileMatchLog);
